export default __webpack_public_path__ + "1337dd0f6a23a6cbfa0e63a89960b49f.png";